import { colorClasses } from "../constants/color";
import { CircleLoading } from "../icons/CircleLoading";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	onClick?: () => void;
	className?: string;
	isLoading?: boolean;
	color?: "red" | "blue" | "green" | "roseWhite" | "purple" | "violet" | "mutedViolet";
	secondary?: boolean;
	size?: "sm" | "md" | "lg";
	children: React.ReactNode;
}

export const Button: React.FC<ButtonProps> = ({ onClick, children, className = "", isLoading = false, color = "", size = "md", secondary = false, ...props }) => {
	const themeColor = colorClasses[secondary ? "secondary" : "primary"][color] || colorClasses[secondary ? "secondary" : "primary"].default;
	const sizeClasses = {
		sm: "max-md:text-xs text-sm px-4 py-2",
		md: "max-md:text-sm text-md px-5 py-2.5",
		lg: "max-md:text-md text-lg px-6 py-3",
	};
	return (
		<button
			type="button"
			onClick={onClick}
			disabled={isLoading}
			className={`flex justify-center select-none rounded-md items-center ${className}
                transition-colors duration-300 ${sizeClasses[size]} ${themeColor} ${isLoading ? "cursor-not-allowed" : "cursor-pointer"}`}
			{...props}
		>
			{isLoading ? <CircleLoading /> : children}
		</button>
	);
};
